import { render, staticRenderFns } from "./AnagraficaBarche.vue?vue&type=template&id=1663b914&scoped=true&"
import script from "./AnagraficaBarche.vue?vue&type=script&lang=js&"
export * from "./AnagraficaBarche.vue?vue&type=script&lang=js&"
import style0 from "./AnagraficaBarche.vue?vue&type=style&index=0&id=1663b914&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1663b914",
  null
  
)

export default component.exports